/** 创作者端、官网等对外统一展示的官方联系邮箱（与 AI 提示词、后端 env 默认值保持一致） */
export const OFFICIAL_CONTACT_EMAIL = 'contact@fundamuse.com' as const;

export const OFFICIAL_CONTACT_MAILTO_HREF = `mailto:${OFFICIAL_CONTACT_EMAIL}` as const;
